<template>
    <CContainer fluid>
        <h3>Indicadores de Ventas</h3>
        <CCard class="mt-4">
            <CCardHeader>
                <CRow>
                    <CCol col="3" sm="3">
                      <label class="col-sm-12 text-muted font-weight-bold">
                        Fecha Inicial:
                      </label>
                      <DatePicker 
                        type="date"
                        class="col-sm-12"
                        v-model="fechaInicial"
                        value-type="YYYY-MM-DD"
                        format="DD/MM/YYYY"
                        placeholder="dd/mm/yyyy" />
                    </CCol>
                    <CCol col="sm-3">
                      <label class="col-sm-12 text-muted font-weight-bold">
                        Fecha Final:
                      </label>
                      <DatePicker 
                        type="date"
                        class="col-sm-12"
                        v-model="fechaFinal"
                        value-type="YYYY-MM-DD"
                        format="DD/MM/YYYY"
                        placeholder="dd/mm/yyyy" />
                    </CCol>
                    <CCol col="sm-6">
                      <CButton 
                        color="info" 
                        variant="outline" 
                        class="mt-4"
                        @click="getDataSalesAndCosts()">
                        <CIcon name="cil-search" />
                        <span class="ml-2 align-middle">Consultar</span>
                      </CButton>
                    </CCol>
                </CRow>
            </CCardHeader>
            <CCardBody>
                <CRow>
                    <!-- <CCol col="sm-3">
                        <CWidgetIcon 
                            color="s3green" 
                            text="Valor de Ventas" 
                            :header="'$' + formatter.format(valorMercancia, 2) + 'M'" 
                            :icon-padding="false">
                            <i class="bi bi-cart3 h1"></i>
                        </CWidgetIcon>
                    </CCol>
                    <CCol col="sm-3">
                        <CWidgetIcon 
                            color="warning" 
                            text="Valor Costo"
                            :header="'$' + formatter.format(valorCosto, 2) + 'M'"
                            :icon-padding="false">
                            <i class="bi bi-cash-stack h1"></i>
                        </CWidgetIcon>
                    </CCol>
                    <CCol col="sm-3">
                        <CWidgetIcon
                            color="info"
                            text="Valor Utilidad"
                            :header="'$' + formatter.format(valorUtilidad, 2) + 'M'"
                            :icon-padding="false">
                            <i class="bi bi-graph-up-arrow h1"></i>
                        </CWidgetIcon>                                
                    </CCol>
                    <CCol col="sm-3">
                        <CWidgetIcon 
                            color="s3red" 
                            text="Remisiones" 
                            :header="'$' + formatter.format(123.45, 2) + 'M'"
                            :icon-padding="false">
                            <i class="bi bi-box-seam h1"></i>
                        </CWidgetIcon>
                    </CCol> -->
                    <CCol col="sm-3">
                      <CWidgetProgressIcon
                        color="s3green"
                        text="Valor de Ventas"
                        :value="0"
                        :header="'$' + formatter.format(valorMercancia, 2) + 'M'">
                        <template #progress>
                          <!-- <a href="#" v-if="$store.state.user.data.tipo_Empleado !== 'V'" -->
                          <a href="#"
                            class="ml-2" 
                            @click="() => {
                              showDetailSales = !showDetailSales
                            }">
                            <i :class="showDetailSales ? 'bi bi-caret-up-square' : 'bi bi-caret-down-square'"></i>
                          </a>
                          <a href="#" v-if="$store.state.user.data.tipo_Empleado === 'V'" 
                            class="ml-2" 
                            @click="() => {
                              renderGridSalesProfit = true
                              tipoReporte = 'C'
                              updateComponentGrid += 1
                              showPanelDetailUtility = true
                            }">
                            <i class="bi bi-journal-text"></i>
                          </a>
                        </template>
                        <i class="bi bi-cart3 h1 text-s3green"></i>
                      </CWidgetProgressIcon>                                
                    </CCol>
                    <CCol col="sm-3">
                      <CWidgetProgressIcon
                        text="Valor Costo"
                        color="warning"
                        :value="participacionCosto"
                        :header="'$' + formatter.format(valorCosto, 2) + 'M'">
                        <template #progress>
                            &nbsp;
                        </template>
                        <i class="bi bi-cash-stack h1 text-warning"></i>
                      </CWidgetProgressIcon>                                
                    </CCol>
                    <CCol col="sm-3">
                      <CWidgetProgressIcon
                        text="Valor Utilidad"
                        color="info"
                        :value="porcentajeUtilidad"
                        :header="'$' + formatter.format(valorUtilidad, 2) + 'M'">
                        <template #progress>
                            &nbsp;
                            <!-- <a href="#" @click="() => showDetailUtility = !showDetailUtility">
                                <i class="bi bi-caret-down-square ml-2"></i>
                            </a> -->
                        </template>
                        <span class="small text-info mr-2">{{ porcentajeUtilidad }}%</span>
                        <i class="bi bi-graph-up-arrow h1 text-info"></i>
                      </CWidgetProgressIcon>                                
                    </CCol>
                    <!-- <CCol col="sm-3">
                        <CWidgetProgressIcon
                            text="Remisiones"
                            color="s3red"
                            :value="51"
                            :header="'$' + formatter.format(123.45, 2) + 'M'">
                            <template #progress>
                                &nbsp;
                            </template>
                            <span class="small text-s3red mr-2">00.00%</span>
                            <i class="bi bi-box-seam h1 text-s3red"></i>
                        </CWidgetProgressIcon>
                    </CCol> -->
                </CRow>
            </CCardBody>

            <CElementCover v-show="loading"/>
        </CCard>

    <CCard>
      <CCardBody>
        <CRow>
          <CCol col="6" sm="6">
            <CCard class="h-100">
              <CCardBody>
                <DailySalesParticipationChart v-if="showChart"
                  title="Comportamiento Ventas diarias"
                  :initialDate="fechaInicial" 
                  :finalDate="fechaFinal" 
                  :valuesDivisor="divisorValores"
                  :valuesSing="'M'"
                  :key="updateComponent" >
                </DailySalesParticipationChart>
              </CCardBody>
            </CCard>
          </CCol>
          <CCol col="12" sm="6">
            <CCard class="h-100">
              <CCardBody>
                <div class="d-flex justify-content-end">
                  <a href="#" 
                    @click="() => {
                      renderGridSalesProfit = true
                      showPanelDetailCategoryUtility = true
                    }">
                    <i class="bi bi-three-dots h4"></i>
                  </a>
                </div>
                <SalesParticipationCategoryChart v-if="showChart"
                  title="Participación Ventas por Categoría" 
                  reportType="C" 
                  utilityType="venta" 
                  :initialDate="fechaInicial" 
                  :finalDate="fechaFinal" 
                  :idEmployee="idEmpleado"
                  :valuesDivisor="divisorValores"
                  :valuesSing="'M'"
                  :key="updateComponent" >
                </SalesParticipationCategoryChart>
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>

    <CCard>
      <CCardBody>
        <CRow>
          <CCol col="8" sm="4" v-if="$store.state.user.data.tipo_Empleado === 'A' || $store.state.user.data.tipo_Empleado == 'D'">
            <CCard class="h-100">
              <CCardBody>
                <div class="d-flex justify-content-end">
                  <!-- <a href="#" 
                    v-c-tooltip="'Detallado por Grupo'" 
                    class="mr-2" @click="() => {
                      renderGridSalesProfit = true
                      tipoReporte = 'G'
                      updateComponentGrid += 1
                      showPanelDetailUtility = true
                    }">
                    <i class="bi bi-people h4"></i>
                  </a> -->
                  <!-- <a href="#" 
                    v-c-tooltip="'Detallado por Comercial'" 
                    class="mr-2"
                    @click="() => {
                      renderGridSalesProfit = true
                      tipoReporte = 'V'
                      updateComponentGrid += 1
                      showPanelDetailUtility = true
                    }">
                    <i class="bi bi-person-badge h4"></i>
                  </a> -->
                  <a href="#" 
                    @click="() => {
                      renderGridSalesProfit = true
                      showPanelDetailUtility = true
                    }">
                    <i class="bi bi-three-dots h4"></i>
                  </a>
                </div>
                <SalesParticipationChart v-if="showChart"
                  :title="titulo" 
                  :initialDate="fechaInicial"
                  :finalDate="fechaFinal" 
                  :type-report="tipoReporte" 
                  :idEmployeeGroup="idGrupoEmpleado"
                  :idEmployee="null" 
                  :min-percentage="minPercentage"
                  :valuesDivisor="divisorValores"
                  :key="updateComponent">
                </SalesParticipationChart>
              </CCardBody>
            </CCard>
          </CCol>

          <CCol col="12" sm="8">
            <CCard class="h-100">
              <CCardBody>
                <SalesRankingChart v-if="showChart"
                  title="Posicionamiento de Comerciales por Ventas"
                  :initialDate="fechaInicial" 
                  :finalDate="fechaFinal"
                  :reportType="'V'"
                  :utilityType="'venta'"
                  :orderBy="'Valor_Mercancia'"
                  :valuesDivisor="divisorValores"
                  :valuesSing="'M'"
                  :key="updateComponent" >
                </SalesRankingChart>
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>

    <CCollapse :show="showDetailSales">
    </CCollapse>

    <CCollapse :show="showDetailUtility">
      <CCard>
        <CCardBody>
          <div class="mt-2">
            <a href="#" v-c-tooltip="'Utilidad por Grupo'" class="mr-2">
              <i class="bi bi-people h2"></i>
            </a>
            <a href="#" v-c-tooltip="'Utilidad por Comercial'">
              <i class="bi bi-person-badge h2"></i>
            </a>
          </div>
        </CCardBody>
      </CCard>
    </CCollapse>

    <CCard>
      <CCardBody>
        <CRow>
          <CCol col="2">
            <CButton 
              color="info" 
              variant="outline" 
              @click="goToUtilidadVentasDocumento()">
              <i class="bi bi-file-earmark-bar-graph h1"></i>
              <br>
              <span>Utilidad de Ventas por Documento</span>
            </CButton>
          </CCol>
          <CCol col="sm-2" v-if="$store.state.user.data.tipo_Empleado === 'A'">
            <CButton 
              color="s3purple" 
              variant="outline" 
              @click="goToPresupuestoVentaCategoria()">
              <i class="bi bi-bar-chart-line h1"></i>
              <br>
              <span>Presupuestos de Ventas Categor&iacute;as</span>
            </CButton>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>

    <RightSideBar :show="showPanelDetailUtility" size="lg" class="bg-s3grey">
      <CContainer>
        <CCard class="mt-4">
          <CCardHeader>
            <CCardTitle>
              Ventas y Utilidades
            </CCardTitle>
            <CCardSubtitle>
              Detalle de ventas y utilidades por {{ subtitulo }}.
            </CCardSubtitle>
          </CCardHeader>
          <CCardBody>
            <SalesProfit v-if="renderGridSalesProfit"
              :initDate="fechaInicial" 
              :endDate="fechaFinal" 
              :reportType="tipoReporte" 
              :utilityType="'venta'" 
              :idEmployee="tipoReporte === 'C' ? $store.state.user.data.id_Empleado : null"
              :key="updateComponentGrid">
            </SalesProfit>
          </CCardBody>
          <CCardFooter>
            <div class="d-flex justify-content-center">
              <CButton 
                color="primary"
                @click="showPanelDetailUtility = false">
                <CIcon name="cil-x-circle" />
                <span class="align-middle mx-2">Cerrar</span>
              </CButton>
            </div>
          </CCardFooter>
        </CCard>
      </CContainer>
    </RightSideBar>

    <RightSideBar :show="showPanelDetailCategoryUtility" size="lg" class="bg-s3grey">
      <CContainer>
        <CCard class="mt-4">
          <CCardHeader>
            <CCardTitle>
            </CCardTitle>
          </CCardHeader>
          <CCardFooter>
            <div class="d-flex justify-content-center">
              <CButton 
                color="primary"
                @click="showPanelDetailCategoryUtility = false">
                <CIcon name="cil-x-circle" />
                <span class="align-middle mx-2">Cerrar</span>
              </CButton>
            </div>
          </CCardFooter>
        </CCard>
      </CContainer>
    </RightSideBar>



  </CContainer>
</template>
<script>
  import "vue2-datepicker/index.css";
  import { ref } from "vue";
  import moment from "moment";
  import DatePicker from "vue2-datepicker";
  import { formatter } from "../../general";
  import { dataCostoVentasDocumentos } from "../../apiData";

  import RightSideBar from "../containers/RightSideBar.vue";
  import SalesProfit from "../datagrids/SalesProfit.vue";

  import SalesParticipationChart from "@/modules/sales/components/charts/SalesParticipationChart.vue";
  import SalesParticipationCategoryChart from "../charts/SalesParticipationCategoryChart.vue";
  import DailySalesParticipationChart from "@/modules/sales/components/charts/DailySalesParticipationChart.vue";
  import SalesRankingChart from "@/modules/sales/components/charts/SalesRankingChart.vue";

    export default {
        name: "DashboardSales",
        data() {
            return {
                formatter,
                loading: false,
                updateComponent: 0,
                updateComponentGrid: 0,
                showChart: false,
                renderGridSalesProfit: null,
                showChartGroup: null,
                showDetailSales: false,
                showDetailUtility: false,
                showPanelDetailUtility: null,
                showPanelDetailCategoryUtility: null,
                divisorValores: 1000000,
                titulo: "",
                subtitulo: "",
                fechaInicial: "",
                fechaFinal: "",
                tipoReporte: "",
                minPercentage: 5,
                idGrupoEmpleado: null,
                idEmpleado: null,
                valorMercancia: 0,
                valorCosto: 0,
                valorUtilidad: 0,
                valorRemisiones: 0,
                participacionVentas: 0,
                participacionCosto: 0,
                porcentajeUtilidad: 0
            }
        },
        components: {
            DatePicker,
            RightSideBar,
            SalesProfit,
            SalesParticipationChart,
            SalesParticipationCategoryChart,
            DailySalesParticipationChart,
            SalesRankingChart
        },
        methods: {
          async getDataSalesAndCosts() {
            this.loading = true;

            try {
              this.updateComponent += 1;

              const parameters = {
                "Fecha_Inicial": this.fechaInicial,
                "Fecha_Final": this.fechaFinal,
                "Tipo_Reporte": "T",
                "Tipo_Utilidad": "venta",
                "Id_Personal": this.$store.state.user.data.id_Empleado
              }
              const { response } = await dataCostoVentasDocumentos(this, parameters);

              this.valorMercancia = (response[0].Valor_Mercancia / this.divisorValores)
              this.valorCosto = (response[0].Valor_Costo / this.divisorValores)
              this.valorUtilidad = (response[0].Valor_Utilidad / this.divisorValores)
              this.porcentajeUtilidad = response[0].Porcentaje_Utilidad

              this.participacionCosto = ((this.valorCosto / this.valorMercancia) * 100)
              this.participacionUtilidad = ((this.valorUtilidad / this.valorMercancia) * 100)
            } catch (error) {
              console.log(error);
            } finally {
              this.loading = false;
            }
          },
          goToUtilidadVentasDocumento() {
            this.$router.push({
              path: `${this.rootPath}/utilidadventasdocumentos`
            });
          },
          goToPresupuestoVentaCategoria() {
            this.$router.push({
              path: `${this.rootPath}/ejecucionpresupuestoscategorias`
            });
          }
        },
        setup() {
          const rootPath = ref("");

          return {
            rootPath
          }
        },
        created() {
          this.rootPath = this.$router.currentRoute.fullPath;
          this.fechaInicial = moment().startOf("month").format("YYYY-MM-DD");
          this.fechaFinal = moment().format("YYYY-MM-DD");
        },
        mounted() {
          try {
            switch (this.$store.state.user.data.tipo_Empleado) {
              case "A":
                this.tipoReporte = "G";
                this.titulo = "Participacion Ventas por Grupos";
                break;
              case "D":
                this.tipoReporte = "V";
                this.titulo = "Participacion Ventas por Comerciales";
                this.idGrupoEmpleado = this.$store.state.user.data.id_GrupoPersonal;
                break;
              case "V":
                this.idEmpleado = this.$store.state.user.data.id_Empleado;
                this.subtitulo = "Clientes";
                break;
            }
  
            this.getDataSalesAndCosts();

            this.showChart = true;
          } catch (error) {
            console.log(error);
          }
        }
    }
</script>
